export default "__VITE_ASSET__Cn$kSSrY__"